import { Language } from 'ha/i18n';
import { hasLanguage } from 'ha/helpers/routes';
import removeTrailingSlash from 'ha/utils/urls/removeTrailingSlash';
import { removeLangPrefix } from 'ha/utils/urls/removeLangPrefix';

export default (nextState, replace, callback) => {
  if (!hasLanguage(nextState)) {
    replace({
      ...nextState.location,
      pathname: removeTrailingSlash(nextState.location.pathname),
    });
  }

  if (nextState.params.lang === Language.en) {
    replace({
      ...nextState.location,
      pathname: removeLangPrefix(nextState.location.pathname),
    });
  }

  callback();
};
